import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Card, Tooltip } from 'antd';
import { DragDropCtx } from 'context/drag-drop-provider';
import { useContext } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { AutoSizer, List as VirtualizedList } from 'react-virtualized';
import '../../pages/quartermaster.less';
import OnboardPobListItem from './onboard-item';
import { QMCurrentStateCtx } from 'components/quartermaster/state';
import { getDomNodeRef } from 'common/util-ts';
import { PobListSelectionProps } from '../pob-list-selection';

export interface OnboardPobListProps extends PobListSelectionProps {
	data: any[];
}

const OnboardPobList: React.FC<OnboardPobListProps> = (props) => {
	const dragState = useContext(DragDropCtx);
	const { setAddPobDrawerOpen } = useContext(QMCurrentStateCtx);

	let isDisabled = dragState?.source?.droppableId === 'onboard';

	return (
		<>
			{/* Onboard passengers list */}
			<Card
				style={{ height: '100%' }}
				className='mc-qm-card mc-qm-card-onboard'
				bodyStyle={{
					height: '100%',
					padding: 0,
				}}
				title={
					<>
						<FontAwesomeIcon icon={['fas', 'users']} />
						<span>Onboard Passengers</span>
						<span style={{ marginLeft: 6 }}>({props.data.length})</span>
					</>
				}
				extra={
					<div className='mc-qm-card-actions'>
						<Tooltip title='Create Passenger'>
							<Button
								size='small'
								shape='circle'
								type='primary'
								icon='plus'
								className='mc-btn-green'
								onClick={() => setAddPobDrawerOpen(true)}
							/>
						</Tooltip>
					</div>
				}
				size='small'
			>
				<Droppable
					droppableId='onboard'
					mode='virtual'
					isDropDisabled={isDisabled}
					renderClone={(provided, snapshot, rubric) => (
						<OnboardPobListItem
							key={props.data[rubric.source.index]?._id}
							pobObj={props.data[rubric.source.index]}
							provided={provided}
							className='mc-quartermaster-pob-card mc-quartermaster-pob-card-dragging'
						/>
					)}
				>
					{(provided, snapshot) => {
						return (
							<AutoSizer>
								{({ height, width }) => (
									<VirtualizedList
										style={{ marginTop: 1 }}
										height={height}
										width={width}
										rowHeight={46}
										rowCount={props.data.length}
										ref={getDomNodeRef(provided.innerRef)}
										rowRenderer={({ index, style }) => {
											if (!props.data[index]) {
												console.error(
													'PobNode object at index ' + index + ' is NULL'
												);
											}
											return (
												<Draggable
													key={props.data[index]?._id}
													draggableId={props.data[index]?._id}
													index={index}
													// Drag-and-drop feature is temporarily disabled.
													isDragDisabled
												>
													{(provided) => (
														<OnboardPobListItem
															pobObj={props.data[index]}
															style={style}
															provided={provided}
															className='mc-quartermaster-pob-card'
															selectionEnabled={
																props.selectionEnabled
															}
															selected={props.selectedPobIds.includes(
																props.data[index]?._id
															)}
															onSelectedChange={() =>
																props.onPobSelectionChange(
																	props.section,
																	props.data[index]?._id
																)
															}
														/>
													)}
												</Draggable>
											);
										}}
									/>
								)}
							</AutoSizer>
						);
					}}
				</Droppable>
			</Card>
		</>
	);
};

export default OnboardPobList;
